import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBars, FaSignOutAlt, FaUserShield } from 'react-icons/fa';
import '../mobile.css';

const AppHeader = () => {
  const navigate = useNavigate();
  // MobileLayout (and this component) persists across child-route changes
  // (e.g. /m/login -> /m/cases after a successful login), so firstName/role
  // must be re-read from localStorage on every navigation, not cached once
  // in state on mount - otherwise the header never appears post-login.
  useLocation();
  const name = localStorage.getItem('firstName') || '';
  const role = localStorage.getItem('role') || '';
  const firstName = role === 'Advocate' ? `Advocate ${name}` : name;

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(false);
    localStorage.clear();
    navigate('/', { replace: true });
  };

  if (!firstName) return null;

  return (
    <div className="m-header">
      <div className="m-header-user">
        <button
          className="m-hamburger"
          onClick={() => navigate('/m/profile')}
          aria-label="Open profile menu"
        >
          <FaBars size={16} />
        </button>
        <span className="m-welcome-text">{firstName}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        {role === 'admin' && (
          <button className="m-logout-btn" onClick={() => navigate('/m/admin')} aria-label="Admin" title="Admin">
            <FaUserShield size={20} color="#094268" />
          </button>
        )}
        <button className="m-logout-btn" onClick={() => setShowLogoutConfirm(true)} aria-label="Logout" title="Logout">
          <FaSignOutAlt size={20} color="red" />
        </button>
      </div>

      {showLogoutConfirm && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setShowLogoutConfirm(false)} className="m-pill-btn" style={{ color: '#094268', fontWeight: 600 }}>Cancel</button>
              <button className="m-button-primary" style={{ width: 'auto', padding: '8px 14px', background: '#D32F2F' }} onClick={handleLogout}>Logout</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppHeader;
